import React from 'react';
import { useLocation } from 'react-router-dom';
import './Auth.css';

const PasswordlessWaitingPage = () => {
  const location = useLocation();
  const email = location.state?.email || '';
  const isSignup = location.state?.isSignup || false;

  return (
    <div className="auth-container passwordless-waiting-container">
      <div className="auth-form-wrapper passwordless-waiting-wrapper">
        <div className="auth-waiting-content">
          <svg className="auth-email-icon" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
          
          <h2 className="auth-title">CHECK YOUR EMAIL</h2>
          
          <p className="auth-waiting-text">
            We've sent a {isSignup ? 'sign-up' : 'sign-in'} link to
          </p>
          
          <p className="auth-waiting-email">{email}</p>
          
          <p className="auth-waiting-instruction">
            Click the link in your email to continue
          </p>
          
          <div className="auth-waiting-note">
            <p>The link will expire in 1 hour.</p>
            <p>If you don't see the email, check your spam folder.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordlessWaitingPage;

